import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { getFirestore, enableNetwork, disableNetwork, connectFirestoreEmulator, enableIndexedDbPersistence, initializeFirestore, CACHE_SIZE_UNLIMITED } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDBbh7lSZnrrw5SOSjQYwm2vILkSaALlcU",
  authDomain: "agency-superchat-engine.firebaseapp.com",
  projectId: "agency-superchat-engine",
  storageBucket: "agency-superchat-engine.appspot.com",
  messagingSenderId: "190890674153",
  appId: "1:190890674153:web:default",
  measurementId: "G-DEFAULT"
};

console.log('Firebase config:', firebaseConfig);

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Configure Firestore with offline persistence and better settings
const db = getFirestore(app);

// Configure Firestore settings for better offline support
try {
  initializeFirestore(app, {
    localCache: CACHE_SIZE_UNLIMITED,
    experimentalForceLongPolling: true,
    useFetchStreams: false
  });
} catch (err) {
  // Firestore already initialized
}

// Enable offline persistence
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code == 'failed-precondition') {
    console.log('Multiple tabs open, persistence can only be enabled in one tab at a time.');
  } else if (err.code == 'unimplemented') {
    console.log('The current browser does not support all of the features required to enable persistence');
  }
});

const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

export { app, auth, db, storage, googleProvider, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut };